import { Component, Input, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MapElement } from '../../../shared/map/map-element.model';
import { Point } from 'geojson';
import { BaseComponent } from '../../../components/general/base/base.component';
import { MeasurementsActionService } from './measurements-action.service';

@Component({
  selector: 'qm-measurements-action',
  templateUrl: './measurements-action.component.html',
  styleUrls: ['./measurements-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeasurementsActionComponent extends BaseComponent {
  @Input() public tooltipContents: string;
  @Input() public icon?: string = 'tachometer';
  @Input() public selectedFeature: MapElement<Point>;
  @Output() public detailsOpened: EventEmitter<void> = new EventEmitter();

  constructor(
    private measurementsActionService: MeasurementsActionService,
    protected cdr: ChangeDetectorRef
  ) {
    super();
    this.name = 'MeasurementsActionComponent';
  }

   /**
   * Select currently hovered feature
   */
  public openDetails(): void {
    this.measurementsActionService.openDetails(this.selectedFeature);
    this.detailsOpened.emit();
  }
}
